module.exports = __webpack_public_path__ + "static/media/Work_Order_Template_1.8e4cd653.png";